// Package imports:
import React, { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
// Style imports:
// import './SigtiHome.scss';
// Component imports:
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import DatePicker from '../common/DatePicker';
import AlertStats from '../alerts/AlertStats';
import HomeTradesLatest from './HomeTradesLatest';
import HomeAlerts from '../alerts/HomeAlerts';
import HomeBookmarks from '../bookmarks/HomeBookmarks';
// Action imports:
import { requestAlerts } from '../../redux-store/actions/alertActions';
// Type imports:
import { RootState } from '../../redux-store/reducers';

type ReduxProps = ConnectedProps<typeof connector>;
type Props = ReduxProps;

const SigtiHome: React.FC<Props> = ({
    alertsByDate,
    currentTradingDay,
    accessTokenV2,
    requestAlerts
}) => {
    useEffect(() => {
        document.title = 'Overview | KODIAK Sigti';
    }, []);

    useEffect(() => {
        const alertInfo = alertsByDate[currentTradingDay];
        if (
            accessTokenV2 &&
            currentTradingDay &&    
            (alertInfo === undefined)
        ) {
            requestAlerts(accessTokenV2, currentTradingDay, currentTradingDay);
        }
    }, [ accessTokenV2, currentTradingDay, alertsByDate, requestAlerts ]);

    return (
        <Container fluid id='SigtiHome'>
            <Row className='SecondaryNavBar'>
                <Col xs={12} className='SecondaryNavBarCol'>
                    <DatePicker/>
                    <div className='AlertStatsWrapper'>
                        <AlertStats
                            isLinks={true}
                            alertsByDate={alertsByDate}
                            currentTradingDay={currentTradingDay}
                            dayRange={undefined}
                        />
                    </div>
                </Col>
            </Row>
            <div className='SigtiHomePanelRow'>
                <div className='TradesAndBookmarkWrapper'>
                    <HomeTradesLatest />
                    <HomeBookmarks
                        showDateInTimestamp={false}
                        currentTradingDay={currentTradingDay}
                        reverseSort={false}
                    />
                </div>
                <HomeAlerts
                    currentTradingDay={currentTradingDay}
                    dayRange={undefined}
                    showDateInTimestamp={false}
                    hideScrollbarInTable={false}
                />
            </div>
        </Container>
    );
}

function mapStateToProps({ dashboardReducer, alertReducer, loginReducer }: RootState) {
    const { currentTradingDay } = dashboardReducer;
    const { accessTokenV2 } = loginReducer;
    const { alertsByDate } = alertReducer;
    return {
        currentTradingDay,
        accessTokenV2,
        alertsByDate
    };
}

const connector = connect(mapStateToProps, { requestAlerts });
export default connector(SigtiHome);